var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBlueRadioSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon blue-radio-icon",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    stroke: "#5d9cec"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "inner-circle",
    cx: 10,
    cy: 10,
    r: 7
  }))));
}

export default SvgBlueRadioSv;